import { Divider, Grid, Typography } from "@mui/material";
import { ReactComponent as OrdersEmptyState } from 'assets/svg/IconOrdersEmptyState.svg'
import { Colors } from 'helpers/Consts'
import { Box } from "@mui/system";

type Props = {
  placeInfo: any;
  toggleDrawer: () => void;
}

export function EmptyShoppingBag({placeInfo, toggleDrawer}: Props) {
  return (
    <>
      <Box p={2} minWidth={"360px"}>
        <Box padding="20px">
          <Typography
            color={Colors.baseTextColor}
            style={{ fontWeight: 300 }}
          >
            Seu pedido em
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" style={{ fontWeight: 700 }}>
              {placeInfo?.name}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <Typography
              color="primary"
              onClick={toggleDrawer}
              sx={{ cursor: "pointer" }}
            >
              Ver Cardápio
            </Typography>
          </Box>
          <Typography
            fontSize="14px"
            style={{
              fontWeight: 700,
              marginTop: "10px",
            }}
          >
            Produtos:
          </Typography>
          <Divider />

    <Grid container justifyContent='center' sx={{marginTop: '25px'}}>
      <Grid item xs={12} sm={6} md={5}>
        <OrdersEmptyState height='35%' width='100%' />
        <Typography
          sx={{ fontSize: '1.25rem' }}
          textAlign='center'
          color={Colors.baseTextColor}
          fontWeight='500'
        >
          Seu carrinho está vazio.
        </Typography>
        <Typography
          sx={{ fontSize: '0.8rem' }}
          textAlign='center'
          color={Colors.baseTextColor}
        >
          Adicione alguns produtos e peça já sua refeição.
        </Typography>
      </Grid>
    </Grid>
        </Box>
      </Box>
      </>

  )
}